import React, { useCallback, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useMsal } from "@azure/msal-react";
import { useModalContext } from "../ModalContext";
import ToggleButton from "./ToggleButton";
import { useLocation } from "react-router-dom";

function ProfileDetails() {
  //  state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = useState(null);
  const { instance } = useMsal();
  const location = useLocation();
  const open = Boolean(anchorEl);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const userName = localStorage.getItem("username");

    try {
      // Attempt to parse as JSON
      const parsedData = JSON.parse(userData);
      const parsedData02 = JSON.parse(userName);

      setUser(parsedData, parsedData02);
    } catch (error) {
      // If parsing fails, treat it as a plain string
      setUser({ name: userData, userName: userName });
    }
  }, []);

  // handlers
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = useCallback(() => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/",
    });
  }, [instance]);

  const handleLogout = () => {
    // Remove the user details from local storage
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("userValidated");
    // Redirect or update the UI as needed
    logout(); // Redirect to login page
  };

  // const TYPES = ["INR", "Native"];
  // const handleChange = (value) => {
  //   setCurrency(value); // Update global state
  // };

  // Initialize currency from localStorage
  const { currency, setCurrency } = useModalContext();

  useEffect(() => {
    const savedCurrency = localStorage.getItem("currency");
    if (savedCurrency) {
      setCurrency(savedCurrency); // Set global state from localStorage
    }
  }, [setCurrency]);

  const handleToggleChange = (event) => {
    const newCurrency = event.target.checked ? "Native" : "INR";
    setCurrency(newCurrency);
    localStorage.setItem("currency", newCurrency);
  };

  return (
    <div
      style={{
        marginLeft: "auto",
      }}
    >
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: "20px",
          }}
        >
          {/* <BasicSelect
            value={currency}
            setValue={handleChange}
            minWidth = {"fit-content"}
            name=""
            options={TYPES}
            textColor="#fff" 
            iconColor="#fff" 
            borderColor="rgb(20, 148, 133)" 
          /> */}

          {location.pathname === "/current-month-summary" ||
          location.pathname === "/current-month" ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "#fff",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "#000",
                  opacity: currency === "INR" ? 1 : 0.5,
                }}
              >
                INR
              </p>
              <ToggleButton
                checked={currency === "Native"}
                onChange={handleToggleChange}
                backgroundColorTrack={"#149485"}
                backgroundColorThumb={"#149485"}
              />
              <p
                style={{
                  fontSize: "14px",
                  color: "#000",
                  opacity: currency === "Native" ? 1 : 0.5,
                }}
              >
                Native
              </p>
            </Box>
          ) : (
            ""
          )}

          <Tooltip title="Logout">
            <span
              style={{
                fontSize: "14px",
                color: "#000",
              }}
            >
              {user?.userName}
            </span>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar sx={{ width: 30, height: 30, mr: 1, fontSize: "14px" }}>
                {user?.name?.charAt(0).toUpperCase() || "G"}
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <p
            style={{
              fontSize: "14px",
              margin: "0",
              padding: "5px 16px",
            }}
            onClick={handleClose}
          >
            {user?.userName}
          </p>
          <p
            style={{
              fontSize: "14px",
              margin: "0",
              padding: "5px 16px",
              paddingBottom: "15px",
            }}
            onClick={handleClose}
          >
            {user?.name}
          </p>
          <Divider
            sx={{
              marginBottom: "15px",
            }}
          />
          <MenuItem
            sx={{
              fontSize: "14px",
            }}
            onClick={handleLogout}
          >
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </>
    </div>
  );
}

export default ProfileDetails;
